import { render, staticRenderFns } from "./SummaryMailSavingsTables.vue?vue&type=template&id=2e1602ef&scoped=true&"
import script from "./SummaryMailSavingsTables.vue?vue&type=script&lang=js&"
export * from "./SummaryMailSavingsTables.vue?vue&type=script&lang=js&"
import style0 from "./SummaryMailSavingsTables.vue?vue&type=style&index=0&id=2e1602ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1602ef",
  null
  
)

export default component.exports